import Vue from 'vue'
import Vuex from 'vuex'
import util from './modules/util';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userName: null,
    textLabelFileId: null,
  },
  mutations: {
    setUserName(state, val) {
      state.userName = val;
    },
    setTextLabelFileId(state, val) {
      state.textLabelFileId = val;
    },
  },
  actions: {
    updateUserName({commit}, value) {
      commit('setUserName', value)
    },
    updateTextLabelFileId({commit}, value) {
      commit('setTextLabelFileId', value)
    },
  },
  modules: {
    util,
  }
})
